// Display labels for the ACFR (Aged Care Financial Report) service categories that
// tp-assist-api's getACFRCategory() (acfr_mappings.mjs) resolves to. Shared between the ACFR
// report itself (ACFRReport.tsx) and the Claim Items dashboard's acfr_category column so the
// two can never show different names for the same underlying category.
export const ACFR_CATEGORY_LABELS: Record<string, string> = {
  CLINICAL: 'Clinical support services',
  INDEPENDENCE: 'Independence services',
  EVERYDAY_LIVING: 'Everyday living services',
  CARE_MGMT_MAIN: 'Care management',
  RESTORATIVE_CARE: 'Restorative care pathway',
  END_OF_LIFE: 'End of life pathway',
  ATHM: 'Assistive technology & home modifications',
};

/**
 * An unmapped code (e.g. the API adds an 8th category before this map is updated) is blanked
 * rather than shown as a raw internal string — TAV-3298's own rule is that a row the frontend
 * can't confidently render is worse displayed wrong/raw than left blank, same as the backend
 * getter returning null for an ambiguous row rather than guessing.
 */
export const formatAcfrCategory = (category?: string | null): string | null =>
  category ? (ACFR_CATEGORY_LABELS[category] ?? null) : null;
